import { ExchangeRateRefDateMappingConstant } from "presentation/constant/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingConstant";
import { useExchangeRateRefDateMappingVM } from "presentation/hook/ExchangeRateRefDateMapping/useExchangeRateRefDateMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useExchangeRateRefDateMappingTracked } from "presentation/store/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingProvider";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { memo, useCallback, useState } from "react";
import { HPHBreadcrumb, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
const ExchangeRateRefDateMappingTitleBar: React.FC = () => {
    const [exchangeState] = useExchangeRateRefDateMappingTracked();
    const exchangeVM = useExchangeRateRefDateMappingVM();
    const messageBarVM = useMessageBarVM();
    const { currentSelectedRow, masterState } = exchangeState;
    const { editingEntity, isAdd, isEditable, isRead } = masterState;
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;
    const [isLoading, setIsLoading] = useState(false);
    const currentEntity = isRead ? currentSelectedRow : editingEntity;

    const handleReset = useCallback(async () => {
        exchangeVM.onReset();
    }, [exchangeVM]);
    const handleEdit = useCallback(() => {
        exchangeVM.onEditClick(currentEntity);
    }, [currentEntity, exchangeVM])
    const handleSave = useCallback(async () => {
        setIsLoading(true);
        try {
            exchangeVM.onSaveClicked();
            const res = await exchangeVM.onSave(currentEntity, isAdd);
            if (!!!res || !res.success) {
                res?.data && messageBarVM.showError(res?.data ?? 'Save data failed.');
            } else {
                messageBarVM.showSuccess("Save Successfully.");
                exchangeVM.onClose();
                setIsLoading(true);
            }
        } catch (error) {

            messageBarVM.showError('Save data failed.');
        } finally {
            setIsLoading(false)
        }

    }, [currentEntity, isAdd, messageBarVM, exchangeVM]);
    return <Sidebarheader style={{ width: '100%' }}>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <Breadcrumb>
            <HPHBreadcrumb breadcrumbData={[{ title: ExchangeRateRefDateMappingConstant.CATEGORY },
            { title: ExchangeRateRefDateMappingConstant.TITLE }]} onCurrentClick={() => { }}>
            </HPHBreadcrumb>
        </Breadcrumb>
        <StyledAction>
            {allowUpdate && (!(isAdd || isEditable)) && <NbisIconButton fileName='Icon-pen' size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} disabled={false} />}
            {(isAdd || isEditable) && <IconButton fileName="Icon-reset" size="medium" toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={handleReset} />}
            {<IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="left" toolTipText={'Close'} onClick={exchangeVM.onClose} />}
            {(isAdd || isEditable) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
        </StyledAction>
    </Sidebarheader>
}
export default memo(ExchangeRateRefDateMappingTitleBar); 
